'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = promiseMiddleware;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _isPromise = require('./isPromise');

var _isPromise2 = _interopRequireDefault(_isPromise);

var PENDING = 'PENDING';
exports.PENDING = PENDING;
var FULFILLED = 'FULFILLED';
exports.FULFILLED = FULFILLED;
var REJECTED = 'REJECTED';

exports.REJECTED = REJECTED;
var defaultTypes = [PENDING, FULFILLED, REJECTED];
var IS_ERROR = true;

function promiseMiddleware() {
  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var promiseTypeSuffixes = config.promiseTypeSuffixes || defaultTypes;

  return function (_ref) {
    var dispatch = _ref.dispatch;

    return function (next) {
      return function (action) {
        if (!_isPromise2['default'](action.payload)) {
          return next(action);
        }

        var type = action.type;
        var payload = action.payload;
        var meta = action.meta;
        var promise = payload.promise;
        var data = payload.data;

        var _ref2 = (meta || {}).promiseTypeSuffixes || promiseTypeSuffixes;

        var _PENDING = _ref2[0];
        var _FULFILLED = _ref2[1];
        var _REJECTED = _ref2[2];

        /**
         * Dispatch the first async handler. This tells the
         * reducer that an async action has been dispatched.
         */
        next(_extends({
          type: type + '_' + _PENDING
        }, !data ? {} : { payload: data }, !meta ? {} : { meta: meta }));

        var isThunk = function isThunk(resolved) {
          return typeof resolved === 'function';
        };

        var getPartialAction = function getPartialAction(isError) {
          return _extends({
            type: type + '_' + (isError ? _REJECTED : _FULFILLED)
          }, meta === undefined ? {} : { meta: meta }, !isError ? {} : { error: true });
        };

        /**
         * Re-dispatch one of:
         *  1. a thunk, bound to a resolved/rejected object containing ?meta and type
         *  2. a resolve/rejected action with the resolve/rejected object as a payload
         */
        promise.then(function () {
          var resolved = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

          var resolveAction = getPartialAction();
          dispatch(isThunk(resolved) ? resolved.bind(null, resolveAction) : _extends({}, resolveAction, resolved === undefined ? {} : { payload: resolved }));
        }, function () {
          var rejected = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

          var rejectedAction = getPartialAction(IS_ERROR);
          dispatch(isThunk(rejected) ? rejected.bind(null, rejectedAction) : _extends({}, rejectedAction, rejected === undefined ? {} : { payload: rejected }));
        })['catch'](function (error) {
          return(
            // log out any errors thrown as a result of the dispatch in this promise
            console.error(error)
          );
        } // eslint-disable-line
        );

        return promise;
      };
    };
  };
}
